
import React from "react";

const AuthLoadingState = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 py-12 bg-gradient-to-b from-mono-charcoal to-mono-eerieBlack">
      <div className="animate-pulse flex flex-col items-center">
        <div className="h-16 w-16 bg-mono-slateGray/20 rounded-full"></div>
        <div className="mt-6 h-5 w-52 bg-mono-slateGray/20 rounded"></div>
        <div className="mt-3 h-4 w-40 bg-mono-slateGray/20 rounded"></div>
      </div>
    </div>
  );
};

export default AuthLoadingState;
